export default __webpack_public_path__ + "static/media/fovi-header.99493759.jpg";